<ng-container *ngIf="isCompact else template">
  {{ elementLink | trimText: 100 }}
</ng-container>

<ng-template #template>
  {{  elementLink }}
</ng-template>
